import { LocalStorageUtil } from '@cue/utility';
import { Auth, LocalUserData } from './auth';
import { HttpService } from '@cue/api';
import { ApiConfig, apiConfig } from '../config/api-config';

export const AGENDA_BOOKMARKS = 'agendaBookmarks';

export class BookmarkService {
  public static async getBookmarks({
    user,
  }: {
    user: false | LocalUserData | undefined;
  }): Promise<string[]> {
    const localBookmarks = (LocalStorageUtil.get<string[]>(AGENDA_BOOKMARKS) || []) as string[];

    if (!user) return localBookmarks;
    const getBookmarks = await HttpService.get({
      url: `${apiConfig.me}`,
      config: {
        withCredentials: true,
      },
    });

    const bookmarks = JSON.parse(getBookmarks?.data?.person?.fields?.bookmarks)
    // INITIAL SYNC
    if (!bookmarks) {
      const localBookmarks = (LocalStorageUtil.get<string[]>(AGENDA_BOOKMARKS) || []) as string[];
      await BookmarkService.setBookmarks(localBookmarks);
      console.log('INIT SYNC BOOKMARKS');
    }

    return bookmarks

    //return (LocalStorageUtil.get<string[]>(AGENDA_BOOKMARKS) || []) as string[];
  }

  public static async setBookmarks(bookmarks: string[]): Promise<string[] | null> {
    await HttpService.post({
      url: `${apiConfig.me}`,
      config: {
        withCredentials: true,
      },
      data: {
        person: {
          fields: {
            bookmarks: JSON.stringify(bookmarks),
          },
        },
      },
    });

    return bookmarks;

    //LocalStorageUtil.set<string[]>(AGENDA_BOOKMARKS, bookmarks);

    /* const bookmarkData: UserBookmarks = {person: {fields: {bookmarks: JSON.stringify(bookmarked)}}}
            HttpService.post(apiConfig.currentUser, bookmarkData).then(res => {
             
              })
              */

    //return bookmarks;
  }
}
/* const saveSurvey = async (updatedUser: ILocalUser) => {
  const clonedUser = cloneDeep(updatedUser);
  if (clonedUser) {
    for (const key in clonedUser.user.fields) {
      clonedUser.user.fields[key] = JSON.stringify(clonedUser.user.fields[key]);
    }
    setSaving(true);
    await updateFields(clonedUser.user.fields);
    setSaving(false);
    onChange && onChange();
  }
}; */
